import { z } from "zod";

export const registerSchema = z.object({
  email: z
    .string()
    .email("*Veuillez entrer un email valide.")
    .min(1, "*Ce champ est requis."),
  password: z
    .string()
    .min(8, "*Le mot de passe doit contenir au moins 8 caractères.")
    .regex(/[a-z]/, "*Le mot de passe doit contenir au moins une lettre minuscule.")
    .regex(/[A-Z]/, "*Le mot de passe doit contenir au moins une lettre majuscule.")
    .regex(/[0-9]/, "*Le mot de passe doit contenir au moins un chiffre.")
    .regex(/[\W_]/, "*Le mot de passe doit contenir au moins un caractère spécial."),
  confirmPassword: z
    .string()
    .min(8, "*Le mot de passe doit contenir au moins 8 caractères."),
}).refine((data) => data.password === data.confirmPassword, {
  path: ["confirmPassword"],
  message: "*Les mots de passe ne correspondent pas.",
});